@use "~theme/typography";

.buttonBox {
  box-sizing: border-box;
  border-style: solid;
  border-radius: 2px;
  border-color: var(--blue-01-at-30);
  border-width: 1px;
  background-color: var(--blue-02-at-30);
  background-image: url("~images/paper.svg");
  background-position: center center;
  background-repeat: no-repeat;
  height: 150px;
  width: 100%;
  max-width: 408px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 40px;
}

.buttonBoxSigned {
  background-color: var(--gray-04);
}

.buttonBoxError {
  border-color: var(--red);
  border-width: 2px;
}

.pill {
  @include typography.button-large;
  height: 36px;
  border-radius: 100px;
  background-color: var(--black-at-75);
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 164px;

  img {
    margin-right: 8px;
  }
}

.button {
  width: 100%;
  max-width: 254px;
}

.error {
  padding-left: 32px;
  color: var(--red);
  background-image: url("~images/error.svg");
  background-repeat: no-repeat;
  background-position: left center;
}

.legend {
  margin-top: 0.2rem;
}

.printButton {
  position: absolute;
  right: 0;
  top: -32px;
}
